/** @format */

import React from "react";
import { Box, Container as MuiContainer } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
	GroupAdd,
	AutoMode,
	ReceiptLong,
	VerifiedUser,
} from "@mui/icons-material";
import {
	Container,
	HeaderDiv,
	StyledTypography,
	ModernCard,
	IconWrapper,
	CardTitle,
	CardDescription,
	SectionSubtitle,
} from "./styles";

const BannerTwo = () => {
	const { t } = useTranslation("home");
	const features = [
		{
			icon: <GroupAdd />,
			title: t("bannerTwo.easeOfUse"),
			description: t("bannerTwo.easeOfUseDesc"),
		},
		{
			icon: <AutoMode />,
			title: t("bannerTwo.automation"),
			description: t("bannerTwo.automationDesc"),
		},
		{
			icon: <ReceiptLong />,
			title: t("bannerTwo.transparency"),
			description: t("bannerTwo.transparencyDesc"),
		},
		{
			icon: <VerifiedUser />,
			title: t("bannerTwo.security"),
			description: t("bannerTwo.securityDesc"),
		},
	];

	return (
		<Container>
			<MuiContainer maxWidth="xl">
				<HeaderDiv data-aos="fade-up">
					<StyledTypography>{t("bannerTwo.title")}</StyledTypography>
					<SectionSubtitle>
						{t("bannerTwo.subtitle")}
					</SectionSubtitle>
				</HeaderDiv>

				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: {
							xs: "1fr",
							sm: "repeat(2, 1fr)",
							md: "repeat(2, 1fr)",
							lg: "repeat(4, 1fr)",
						},
						gap: 3,
						padding: "40px 0",
					}}>
					{features.map((feature, index) => (
						<ModernCard
							key={index}
							data-aos="fade-up"
							data-aos-delay={index * 100}>
							<IconWrapper>{feature.icon}</IconWrapper>
							<CardTitle>{feature.title}</CardTitle>
							<CardDescription>{feature.description}</CardDescription>
						</ModernCard>
					))}
				</Box>
			</MuiContainer>
		</Container>
	);
};

export default BannerTwo;
